import { PlansSuccess } from '../services/types';
import { RequestStatus } from 'shared/constants/State';
import { IStoreState } from 'state/rootReducer';

export const getPlan = ({ checkout }: IStoreState): PlansSuccess | undefined =>
  checkout.products;

export const isFetchingPlans = ({ checkout }: IStoreState): boolean =>
  checkout.status === RequestStatus.Pending;

export const getPlanStatus = ({ checkout }: IStoreState) => checkout.status;

export const getMostSeller = ({ checkout }: IStoreState) => checkout.mostSeller;

export const getBaseProducts = ({ checkout }: IStoreState) =>
  checkout.products?.plans ?? [];

export const getAddons = ({ checkout }: IStoreState) =>
  checkout.products?.addons ?? [];

export const getClinicId = ({ userInfo }: IStoreState) =>
  userInfo.userData.activeClinicId;

export const getRecurrence = ({ checkout }: IStoreState) => checkout.isAnnual;

export const getSelectedPlan = ({ checkout }: IStoreState) =>
  checkout.selectedPlan;

export const getPhysicians = ({ checkout }: IStoreState) =>
  checkout.physicians ?? [];

export const getSelectedAddons = ({ checkout }: IStoreState) =>
  checkout.selectedAddons ?? [];

export const getPhysicianByAddon = ({ checkout }: IStoreState) =>
  checkout.physiciansByAddon;

export const getSubscriptionStatus = ({ checkout }: IStoreState) =>
  checkout.subscriptionStatus;

export const isSubscribing = ({ checkout }: IStoreState) =>
  checkout.subscriptionStatus === RequestStatus.Pending;

export const getFunctionalities = ({ checkout }: IStoreState) =>
  checkout.products?.functionalities ?? [];

export const isOffCanvasOpen = ({ checkout }: IStoreState): boolean =>
  !!checkout.offCanvasOpen;

export const getFlipCard = ({ checkout }: IStoreState) => checkout.flipCard;

export const getSubscriptionStepMapper = ({ checkout }: IStoreState) =>
  checkout.subscriptionStepMapper;

export const getCurrentSubscriptionStep = ({ checkout }: IStoreState) =>
  checkout.currentSubscriptionStep;

export const getUpdatePermissionUrl = ({ shared }: IStoreState) =>
  shared.updatePermissionsUrl;

export const getSuccessUrl = ({ subscription }: IStoreState) =>
  subscription.successUrl;

export const getErrorsMessage = ({ checkout }: IStoreState) =>
  checkout.errorsMessage ?? [];

export const getAddressData = ({ checkout }: IStoreState) =>
  checkout.addressData;

export const getCouponCode = ({ checkout }: IStoreState) =>
  checkout.products?.coupon ?? undefined;

export const getAppliedVoucher = ({ checkout }: IStoreState) =>
  checkout.appliedVoucher;

export const getVoucherErrorMessage = ({ checkout }: IStoreState) =>
  checkout.voucherErrorMessage;

export const getIsVoucher = ({ checkout }: IStoreState) => checkout.isVoucher;

export const getIsVoucherOrCouponApplied = ({ checkout }: IStoreState) =>
  checkout.isVoucherOrCouponApplied;
